import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=2423edbd&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=2423edbd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423edbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2423edbd')) {
      api.createRecord('2423edbd', component.options)
    } else {
      api.reload('2423edbd', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=2423edbd&scoped=true&", function () {
      api.rerender('2423edbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4eyPy7PGaxptW/JS/comp/Paginate.vue"
export default component.exports